import { render, staticRenderFns } from "./CompositionApiCodeOrganization.vue?vue&type=template&id=288cf15f&scoped=true&functional=true&"
var script = {}
import style0 from "./CompositionApiCodeOrganization.vue?vue&type=style&index=0&id=288cf15f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "288cf15f",
  null
  
)

export default component.exports